var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownLatestArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68566 6.02427C5.2696 6.71039 6.32275 6.72948 6.93116 6.06496L11.8401 0.703374C11.9938 0.535544 11.9842 0.275434 11.8187 0.11933C11.6486 -0.0410599 11.3798 -0.0299625 11.2235 0.143904L6.93522 4.91393C6.32746 5.58997 5.26252 5.5732 4.67636 4.87835L0.675414 0.135622C0.515502 -0.0539374 0.220043 -0.0428099 0.0748438 0.158241C-0.0279947 0.300636 -0.0202566 0.494859 0.0935845 0.628621L4.68566 6.02427Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLatestArrow);
export default __webpack_public_path__ + "static/media/downLatestArrow.d0f5f9ab1ece1e9201a52cfc3978cd02.svg";
export { ForwardRef as ReactComponent };